import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricMeetVsChamp extends MetricBase {
    constructor() {
        super({
            field: "metric_meet_vs_champ_trivago",
            defaultVisibility: true,
            unit: new EmptyUnit(),
         /*   chartName: i18n.t("metrics.trivago.clicks.chartName"),
            serieLabel: i18n.t("metrics.trivago.clicks.serieLabel"),
            tooltip: i18n.t("metrics.trivago.clicks.tooltip"), */
            group: new VisibilityGroup(),
        });
    }
}

export default MetricMeetVsChamp;
